import React from 'react'

export default function FullContent({ children }) {
  return (
    <div className="mtt-loan-modal__full-content">
      {children}
    </div>
  )
}
